import { render } from "./Committeds.vue?vue&type=template&id=5b8db93b&lang=pug"
import script from "./Committeds.vue?vue&type=script&lang=js"
export * from "./Committeds.vue?vue&type=script&lang=js"

import "./Committeds.vue?vue&type=style&index=0&id=5b8db93b&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__